var BaseView = require('./base');
var AnalyticsDecorate = require('../../../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('../analytics/template'), BaseView.extend({
  events: {
    'click': 'addEvent'
  },

  addEvent: function (event) {
    var isEmpty = $('#svgroot .main').find(':not(title)').length === 0;
    var requireNewPage = !this.isSameSize() && !this.isCustomFormat && !isEmpty;

    /* if(requireNewPage)
      this.addOnNewPage();
    else */if (isEmpty || this.setCurrentPage) {
      this.setTemplate();
    } else {
      this.displayModalOptions();
    }
  },

  render: function () {
    BaseView.prototype.render.apply(this, arguments);

    this.baseTemplate
      && this.baseTemplate['is_multipage']
      && this.$el.addClass('set');
  },

  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;

    _.bindAll(this,
      // 'onNewPageCreated',
      'setTemplate',
      'onTemplateSet',
      'acceptModal',
      'closeModal'
    );
  },
  //
  // addOnNewPage: function(layoutData) {
  //   var newPageId = parseInt(INKIVE.C.BOOK.num_pages) + 1;
  //
  //   var data = {
  //     scrapbook_id      : INKIVE.C.BOOK.id,
  //     page              : newPageId
  //   };
  //
  //   var url = INKIVE.C.BASE_URL + 'api/page/add';
  //
  //   INKIVE.Modal.togglePageLoader(true);
  //   $.get(url, data, this.onNewPageCreated);
  // },
  //
  // onNewPageCreated: function(result) {
  //   INKIVE.Modal.togglePageLoader(false);
  //
  //   if(result.status == 'success') {
  //     INKIVE.C.BOOK.num_pages++;
  //     this.tool.load(result.newPageNum, this.setTemplate);
  //   }
  //   else {
  //     INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
  //       message   : 'editor.add_design',
  //       try_again : true
  //     }));
  //   }
  //
  //   INKIVE.Modal.togglePageLoader(false);
  // },

  displayModalOptions: function () {
    var newSize = 0;
    this.modal = INKIVE.Modal.modalWindow(
      INKIVE.TemplatesHelper('modal_layout_load', {
        new_size: newSize,
        current_size: Math.round(this.canvas.contentW) + 'x' + Math.round(this.canvas.contentH),
        keep_images: !INKIVE.C.MODE.IS_DESYGNER,
        has_images: $('#svgcontent .main image').length > 0,
        keep_size: !INKIVE.C.MODE.IS_DESYGNER,
        is_same_size: true
      }),
      {
        width: 600,
        headerIcon: 'icon-cloud-download',
        headerTitle: 'modal.title.change_name',
        buttons: [
          {
            title: INKIVE.TranslateHelper.translate('modal.buttons.apply_name'),
            onClick: this.acceptModal
          }, {
            title: INKIVE.TranslateHelper.translate('general.cancel'),
            onClick: this.closeModal
          }
        ]
      }
    );
  },

  acceptModal: function () {
    this.keepSize = $('input[name="keep-size-input"]').is(':checked');
    this.keepImages = $('input[name="keep-images-input"]').is(':checked');
    this.setTemplate();
    this.modal.close();
  },

  closeModal: function () {
    this.modal.close();
  },

  setTemplate: function () {
    this.oldImages = _.map($('#svgcontent .main image'), function (image) {
      return image.getAttribute('xlink:href');
    });

    this.editor.loadingElement(1);
    INKIVE.DesignFacade.once(this.designAddedEvent, this.onTemplateSet);
  },

  onTemplateSet: function () {
    var $layoutBoxes = $('#svgcontent .main .layoutBox');
    this.keepImages && _.any($layoutBoxes, function (elem, index) {
      if (this.oldImages.length > index) {
        this.canvas.runExtensions('addLayoutImage', {
          elem: elem,
          data: this.oldImages[index]
        });
      } else return true;
    }, this);

    INKIVE.C.IS_MOBILE && this.canvas.call('advice.show', 'template-back');

    INKIVE.C.IS_MOBILE || $layoutBoxes.length && INKIVE.C.MODE.IS_DESYGNER && this.canvas.call('advice.show', 'template-placeholders');
    INKIVE.Helpers.displayImagesLoadingAnimation();

    this.editor.loadingElement(0);

    function afterTemplateImagesLoaded () {
      INKIVE.DesignFacade.trigger('template.update.template_applied_on_current_page');
    }

    // TODO: Replace setTimeout with an image load listener
    setTimeout(afterTemplateImagesLoaded, 5000);
  }
}));
